import React, { useState } from 'react';
import { Dimensions, Platform, ScrollView, StyleSheet, View } from 'react-native';
import { ModalAlignmentEnum } from '@voltmoney/types';
import { isMobile } from '../../stack/utils';
import { getScreenType } from '../bankSelectPage/BankSelect';
import { Header } from "../../header/Header";
import { AspectRatioToken, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, IconSizeTokens, IconTokens, ImageSizeTokens, ResizeModeToken, SizeTypeTokens, StepperTypeTokens, TextAlignTokens } from "@voltmoney/schema";
import { Icon } from "../../icon/Icon";
import { Typography } from "../../typography/Typography";
import { Divider } from "../../divider/Divider";
import { Button } from "../../button/Button";
import { Image } from "../../image/Image";
import { Space } from "../../space/Space";
import BottomSheet from "../BottomSheet";
import { convertToTitleCase } from "../utils";
const NameMismatch = ({ height, stepperData, heading, contactUsAction, triggerAction, tryAgainAction, ctaText, isFromKYC, ifscCode, tryAgainBankAction, key1, value1, key2, value2, backAction, modalContinueAction, userName, showCta1 = true, }) => {
    const [modalHeight, setModalHeight] = useState(248);
    const [showModal, setShowModal] = useState(false);
    const [isDismissable, setDismissable] = useState(true);
    const stepperProps = {
        data: stepperData,
        type: StepperTypeTokens.HORIZONTAL,
        onPress: null
    };
    const handleContinuePress = () => {
        isFromKYC ? triggerAction({
            ...tryAgainAction
        }) : triggerAction({
            ...tryAgainBankAction
        });
    };
    const renderContent = () => {
        return (React.createElement(ScrollView, { scrollEnabled: true, showsVerticalScrollIndicator: false, nestedScrollEnabled: true, contentContainerStyle: { flexGrow: 1, paddingBottom: 20, paddingHorizontal: 16 } },
            React.createElement(View, { style: { justifyContent: 'center', alignItems: 'center', marginTop: 40 } },
                React.createElement(View, { style: { marginBottom: 16 } },
                    React.createElement(Icon, { name: IconTokens.SystemError, size: IconSizeTokens.XXXXXXL })),
                React.createElement(Typography, { label: heading, fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Poppins, fontWeight: "600", color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center })),
            React.createElement(View, { style: { flexDirection: 'column', marginTop: 71, marginBottom: 24 } },
                React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' } },
                    React.createElement(View, { style: { flexDirection: 'column' } },
                        React.createElement(Typography, { label: key1, fontSize: FontSizeTokens.XS, lineHeight: 18, fontWeight: "400", fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal }),
                        React.createElement(Typography, { label: value1, fontSize: FontSizeTokens.MD, lineHeight: 24, fontWeight: "500", fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Night })),
                    React.createElement(Image, { uri: `https://volt-images-alpha.s3.ap-south-1.amazonaws.com/pan1.png`, size: ImageSizeTokens.Size_40, resizeMode: ResizeModeToken.CONTAIN, aspectRatio: AspectRatioToken.A16_9, width: 40, height: 26 })),
                React.createElement(View, { style: { marginTop: 16, marginBottom: 16 } },
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' } },
                    React.createElement(View, { style: { flexDirection: 'column' } },
                        React.createElement(Typography, { label: key2, fontSize: FontSizeTokens.XS, lineHeight: 18, fontWeight: "400", fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal }),
                        React.createElement(Typography, { label: value2, fontSize: FontSizeTokens.MD, lineHeight: 24, fontWeight: "500", fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Night })),
                    isFromKYC ?
                        React.createElement(Image, { uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/aadhaar1.png', size: ImageSizeTokens.Size_40, resizeMode: ResizeModeToken.CONTAIN, aspectRatio: AspectRatioToken.A16_9, width: 50, height: 26 })
                        :
                            React.createElement(Image, { uri: `https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/${ifscCode}.png`, size: ImageSizeTokens.Size_40 })))));
    };
    const modalContentPresenter = () => {
        return (React.createElement(View, { style: {
                display: 'flex',
                flexDirection: 'column',
                padding: 16,
            } },
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%'
                } },
                React.createElement(Icon, { name: isFromKYC ? IconTokens.Verify_Aadhar1 : IconTokens.Verify_Bank1 })),
            React.createElement(Space, { size: SizeTypeTokens.XL }),
            React.createElement(Typography, { label: isFromKYC
                    ? "Verify Aadhaar again"
                    : "Link bank account again", color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Poppins, fontSize: FontSizeTokens.MD, fontWeight: '600', lineHeight: 24, textAlign: TextAlignTokens.center }),
            React.createElement(Space, { size: SizeTypeTokens.MD }),
            React.createElement(View, { style: {
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                } },
                React.createElement(View, { style: { maxWidth: 289 } },
                    React.createElement(Typography, { label: isFromKYC
                            ? `Proceed to verify Aadhaar belongs to ${userName ? convertToTitleCase(userName) : ''}`
                            : `Proceed to link bank account belongs to ${userName ? convertToTitleCase(userName) : ''}`, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, textAlign: TextAlignTokens.center }))),
            React.createElement(Space, { size: SizeTypeTokens.XXXL }),
            React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, label: 'Continue', fontSize: FontSizeTokens.SM, width: ButtonWidthTypeToken.FULL, onPress: () => handleContinuePress() })));
    };
    return (React.createElement(View, { style: { flexDirection: "column", height: Platform.OS === "ios" ? height - 18 : height } },
        React.createElement(View, { style: {
                flex: 1
            } },
            React.createElement(View, { style: styles.headerStyle },
                React.createElement(Header, { type: HeaderTypeTokens.verification, stepperProps: stepperProps, isBackButton: true, title: isFromKYC ? "KYC Verification" : "Link bank account", onPress: () => {
                        triggerAction({
                            ...backAction
                        });
                    } })),
            React.createElement(View, { style: {
                    height: !showCta1 ? height - 198 : height - 245
                } }, renderContent()),
            React.createElement(View, { style: {
                    flexDirection: 'column',
                    position: 'absolute',
                    bottom: 0,
                    alignItems: 'center',
                    borderColor: '#F2F4F7',
                    borderTopWidth: 0.5,
                    width: "100%",
                    alignSelf: 'center',
                    shadowOpacity: 0.08,
                    elevation: 10,
                    paddingHorizontal: 16,
                    paddingTop: 16,
                    // marginHorizontal: -16,
                    // marginBottom: -16,
                    backgroundColor: 'white',
                    shadowOffset: {
                        width: 0,
                        height: -1,
                    },
                    shadowRadius: 5,
                } },
                React.createElement(Typography, { label: isFromKYC ? "Does this Aadhaar belong to you?" : "Does this bank account belong to you?", color: ColorTokens.Grey_Charcoal, fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, fontWeight: '400' }),
                React.createElement(Space, { size: SizeTypeTokens.MD }),
                showCta1 && (React.createElement(React.Fragment, null,
                    React.createElement(Button, { label: isFromKYC ? "Yes, It’s my Aadhaar" : "Yes, It’s my bank account", type: ButtonTypeTokens.LargeFilled, width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, onPress: () => {
                            modalContinueAction &&
                                triggerAction(modalContinueAction);
                        } }),
                    React.createElement(Space, { size: SizeTypeTokens.LG }))),
                React.createElement(Button, { label: isFromKYC ? "No, I provided wrong Aadhaar" : "No, I added wrong bank account", type: ButtonTypeTokens.LargeSoftFilled, width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, onPress: () => {
                        setShowModal(true);
                    } }),
                React.createElement(Space, { size: SizeTypeTokens.XL }))),
        showModal &&
            React.createElement(View, { style: {
                    position: 'absolute',
                    bottom: 0
                } },
                React.createElement(BottomSheet, { autoAdjustHeight: false, height: modalHeight, width: '100%', closeFunction: () => setShowModal(false), alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: isDismissable, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').height : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true }, modalContentPresenter()))));
};
const styles = StyleSheet.create({
    container: {
        height: isMobile(getScreenType(Dimensions.get('window').width))
            ? Dimensions.get('window').height - 70
            : Dimensions.get('window').height,
    },
    headerStyle: {
        ...Platform.OS === "ios" && {
            marginTop: 24
        }
    },
});
export default NameMismatch;
